var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Checkbox } from '@folio/stripes/components';
import { CLAIMING_LIST_COLUMNS } from '../constants';
export var getResultsListColumnMapping = function (_a) {
    var intl = _a.intl, isAllSelected = _a.isAllSelected, selectAll = _a.selectAll, disabled = _a.disabled;
    var mapping = Object.values(CLAIMING_LIST_COLUMNS).reduce(function (acc, column) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[column] = intl.formatMessage({ id: "ui-claims.claiming.results.columns.".concat(column) }), _a));
    }, {});
    return __assign(__assign({}, mapping), { select: (React.createElement(Checkbox, { "aria-label": intl.formatMessage({ id: 'ui-claims.claiming.results.columns.selectAll' }), checked: isAllSelected, onChange: selectAll, type: "checkbox", disabled: disabled })) });
};
